export enum LOGS {
    AgendaManager = "AgendaManager",
    AnalysisLifecycle = "AnalysisLifecycle",
    ApiManager = "ApiManager",
    App = "App",
    AuthProvider = "AuthProvider",
    AuthService = "AuthService",
    BannerManager = "BannerManager",
    CO2Manager = "CO2Manager",
    ConsentManager = "ConsentManager",
    ContactManager = "ContactManager",
    ConversationManager = "ConversationManager",
    CustomViewManager = "CustomViewManager",
    DataManager = "DataManager",
    Events = "Events",
    GoogleManager = "GoogleManager",
    GraphManager = "GraphManager",
    IaManager = "IaManager",
    KeycloakAuth = "KeycloakAuth",
    LicenseManager = "LicenseManager",
    MailManager = "MailManager",
    MailVistaView = "MailVistaView",
    Metrics = "Metrics",
    MusicManager = "MusicManager",
    NetworkProvider = "NetworkProvider",
    Perfs = "Perfs",
    Router = "Router",
    ServiceProvider = "ServiceProvider",
    Storage = "Storage",
    SttManager = "SttManager",
    TESTS = "TESTS",
    Token = "Token",
    UserManager = "UserManager",
    UserProfile = "UserProfile",

    Counters1672 = "Counters1672",

    AB1727 = "AB1727",

    AB1725 = "AB1725",
}

export const ALL_LOG_CATEGORIES = Object.values(LOGS);

const CATEGORY_BY_ID = new Map<string, LOGS>(
    ALL_LOG_CATEGORIES.map((category) => [category as string, category]),
);

export const parseLogCategory = (id: string): LOGS | undefined =>
    CATEGORY_BY_ID.get(id.trim());
